import util from '../util'

let controller = 'Impressao'
export default {
  Get: function (dto) {
    return util.Axios.GetBlob(controller, dto)
  },
  GetAll: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/GetAllComprovantes', dto)
  }
}
